import { FLEX } from "@/styles/common";
import theme from "@/styles/theme";
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import type { ButtonProps } from "./button.type";

export const sizeCSS = {
    large: css`
        height: 48px;
        column-gap: 8px;
    `,

    medium: css`
        width: 144px;
        height: 40px;
        font-size: 14px;
        column-gap: 8px;
    `,

    small: css`
        height: 36px;
        font-size: 14px;
        column-gap: 8px;
    `,

    tiny: css`
        padding: 0 8px;
        height: 22px;
        font-size: 14px;
        column-gap: 4px;
    `,
};

export const borderCSS = {
    default: css`
        border: 1px solid ${theme.COLOR.black};
    `,

    none: css`
        border: none;
    `,
};

export const roundCSS = {
    default: css`
        border-radius: 8px;
    `,

    none: css`
        border-radius: 0px;
    `,

    pill: css`
        border-radius: 999px;
    `,

    full: css`
        border-radius: 50%;
    `,
};

export const StyledButton = styled.button<ButtonProps>`
    ${FLEX.normal("center", "center")}
    font-weight: 500;
    padding: 0 16px;
    cursor: pointer;
    width: ${({ w = "100%" }) => w};
    ${({ size = "large" }) => sizeCSS[size]}
    ${({ border = "default" }) => borderCSS[border]};
    ${({ round = "default" }) => roundCSS[round]}
`;
